import {IATA} from '../../../../utils/config'
import {clone} from '../../../../utils/helper'
import {makeEmptyOrario} from './utils'

export const makeEmptyFlightFilter = () => {
  return {vector: null, orario: makeEmptyOrario(), scalo: null, partenza: null, atterraggio: null}
}

export const makeFlights = (flights, vettori, isAndata = true) => {
  let listFound = []
  let listNotFound = []
  const PV = makePVPrice(flights)
  vettori.list.forEach(vector => {
    const found = flights.find(item => {
      return item.vector.objB === vector.id
    })
    if (found) {
      // ((PM - PV) / PM) * 100 < massima differenza percentuale
      const flight = found.flightAvailabilities[0]
      const PM = Math.round(flight.totale.tariffaVenditaEuro + flight.totale.tasseVenditaEuro)
      const MAX_DIFF_PERC = parseInt(vettori.maxDiffPerc)
      const value = Math.round(((PM - PV) / PM) * 100)
      if (found && value < MAX_DIFF_PERC) {
        const flightNormalized = normalizeFlight(found, flight, isAndata)
        if (flightNormalized.voli.length > 0) {
          listFound.push(flightNormalized)
        } else {
          console.log(`Attenzione vettore ${flightNormalized.vector.objA} ${flightNormalized.vector.objB} senza voli accettabili! Controllare se il vettore ha lo iata di partenza del volo di ritorno corretto.`)
        }
      }
    }
  })
  flights.forEach(item => {
    if (!listFound.some(flight => {
      return flight.vector.objB === item.vector.objB
    })) {
      const flightNormalized = normalizeFlight(item, item.flightAvailabilities[0], isAndata)
      if (flightNormalized.voli.length > 0) {
        listNotFound.push(flightNormalized)
      } else {
        console.log(`Attenzione vettore ${flightNormalized.vector.objA} ${flightNormalized.vector.objB} senza voli accettabili! Controllare se il vettore ha lo iata di partenza del volo di ritorno corretto.`)
      }
    }
  })
  return listFound.concat(listNotFound)
}

const normalizeFlight = (item, avail, isAndata) => {
  const iataList = IATA.split(',')
  let toadd = clone(avail)
  toadd.vector = item.vector
  toadd.prezzoVendita = Math.round(toadd.totale.tariffaVenditaEuro + toadd.totale.tasseVenditaEuro)
  const split = avail.voli.findIndex(function (volo) {
    const iataPartenza = volo.partenza.aeroporto.airport.objB
    return iataList.some((code) => {
      return iataPartenza === code
    })
  })
  toadd.voli = avail.voli.filter((volo, index) => {
    return isAndata ? index < split : index >= split
  })
  // l'aggiunta del campo partenza from al ritorno serve per poter filtrare i voli di ritorno in visualizzazione
  // infatti non sarà possibile scegliere un volo di ritorno non corrispondente al volo andata in termini di
  // vettore e data e ora di partenza dell'andata selezionata
  if (!isAndata) {
    toadd.partenzaFrom = avail.voli[0].partenza
  }
  toadd.durata = avail.tsts[0].segmenti[isAndata ? 0 : 1].eft
  return toadd
}

export const makeDelta = (flights, from) => {
  return flights.map(function (item) {
    item.prezzoVenditaDelta = Math.round(item.prezzoVendita - from.prezzoVendita)
    return item
  })
}

const makePVPrice = (flights) => {
  const flight = flights[0].flightAvailabilities[0]
  return Math.round(flight.totale.tariffaVenditaEuro + flight.totale.tasseVenditaEuro)
}



// WEBPACK FOOTER //
// ./src/front/store/modules/itinerario/actions/flights.js